















import Vue from 'vue';
import { mapGetters } from 'vuex';
import RiskRegisters from './components/RiskRegisters.vue';
import CalculationMethods from './components/CalculationMethods.vue';

export default Vue.extend({
  name: 'ContentTab',
  components: {
    RiskRegisters,
    CalculationMethods,
  },
  computed: {
    ...mapGetters(['featureFlags']),
  },
});
